export default {
  heroSection:{
      title: "Expandiendo el mundo del bitcoin",
      subtitle: "",
      details:"Tu puerta al mundo de Bitcoin y soluciones financieras innovadoras.",
  },
  aboutUsSection: [
    {
      title: "",
      subtitle: `Fundado en 2014, actualmente contamos con una 
      red de cajeros de la marca Cryptobox disponibles en varios 
      puntos de la República Mexicana.`,
      imgPath: "Capa_1.png"
    },
    {
      title: "Visión",
      subtitle: `Poner al alcance de todo México transacciones de manera 
      rápida y sencilla, con todos los beneficios que ofrece Bitcoin por medio 
      de productos y servicios de primera calidad.`,
      imgPath: null
    },
    {
      title: "Misión",
      subtitle: `Desarrollar productos y servicios de fácil y rápido uso, 
      para controlar y administrar tus criptomonedas, 
      desde la palma de tu mano hasta retiro de MXN en nuestra red de cajeros.`,
      imgPath: null
    },
  ],
  montebitProductsSection: {
    headerSection: "MONTEBIT",
    title: "Expandiendo tus límites",
    subtitle: `En Montebit desarrollamos productos y 
    servicios enfocados en tus necesidades como usuario, 
    porque nosotros también somos parte de este gran cambio.`
  },
  whyMontebitSection: [
    {
      title: "Innovación",
      subtitle: `Valoramos la innovación continua y nos esforzamos por estar 
      a la vanguardia de los avances tecnológicos en el espacio de Bitcoin, 
      asegurando que nuestros productos sigan siendo relevantes y confiables.`,
      imgPath: "innovacion-montebit.png"
    },
    {
      title: "Centrado en el cliente",
      subtitle: `Nuestros clientes están en el centro de todo lo que hacemos. Estamos dedicados a 
      comprender sus necesidades y brindar experiencias excepcionales que superen sus expectativas.`,
      imgPath: "cliente-montebit.png"
    },
    {
      title: "Seguridad",
      subtitle: `Mantenemos los más altos estándares de seguridad en todas
      nuestras soluciones, protegiendo los activos y datos de nuestros 
      clientes de posibles amenazas y vulnerabilidades`,
      imgPath: "seguridad-montebit.png"
    },
    {
      title: "Transparencia",
      subtitle: `Somos parte del desarrollo tecnológico del país, en MonteBit fomentamos el uso de 
      herramientas, productos y servicios nacionales que fortalecen el progreso de México.`,
      imgPath: "transparencia-montebit.png"
    },
    {
      title: "Colaboración",
      subtitle: `Fomentamos un entorno de trabajo colaborativo y diverso, 
      fomentando la creatividad y el trabajo en equipo entre nuestros 
      empleados, socios y la comunidad de criptomonedas en general.`,
      imgPath: "colaboracion-montebit.png"
    },
  ],
  contactSection: {
    title: "Contacta con nuestro equipo",
    subtitle: `¿Tienes alguna pregunta o interés? ¡Contáctanos! Estamos aquí para ayudarte.`
  },
  legalSection:[
    {
      subtitle: `<a href='https://montebit.com/aviso%20de%20privacidad%20integral%20_%20Montebit.pdf' target="_blank">Aviso de Privacidad</a>
      <a style="display: block; padding-bottom: 2rem"></a>`,
      imgPath: "montebit-logo.png"
    },
    {
      subtitle: `
                <a href='https://rayyo.mx/aviso-de-privacidad' style="display: block; padding:1rem 0 2rem 0" target="_blank">Aviso de Privacidad</a>
                <a href='https://rayyo.mx/terminos-y-condiciones' style="display: block; padding-bottom: 2rem" target="_blank">Términos y Condiciones</a>
                `,
      imgPath: "Frame 3606.png"
    },
    {
      subtitle: `
                <a href='https://cryptobox.mx/aviso-de-privacidad' style="display: block; padding:3rem 0 2rem 0" target="_blank">Aviso de Privacidad</a>
                <a href='https://cryptobox.mx/terminos-y-condiciones' style="display: block; padding-bottom: 2rem" target="_blank">Términos y Condiciones</a>
                `,
      imgPath: "cryptobox-logo.png"
    }

  ],
  navbarItems: [
    {
      id: "tabId1",
      value: "Nosotros",
      pathName: "#nosotros",
      subMenues: ["na"],
    },
    {
      id: "tabId2",
      value: "Productos",
      pathName: "#productos",
      subMenues: ["na"],
    },
    {
      id: "tabId3",
      value: "¿Por qué Montebit?",
      pathName: "#por-que-montebit",
      subMenues: ["na"],
    },
    {
      id: "tabId4",
      value: "Contacto",
      pathName: "#contacto",
      subMenues: ["na"],
    },
  ],
  footer: {
    items: [
      {
        id: "mont01",
        name: "Rayyo",
        url: "http://rayyo.mx/",
      },
      {
        id: "mont02",
        name: "Cryptobox",
        url: "https://cryptobox.mx/",
      },
      {
        id: "mont03",
        name: "Legales",
        url: "/legal",
      },
    ],
    social: [
      {
        id: "net01",
        name: "facebook",
        url: "https://www.facebook.com/Montebit-101900475954539",
      },
      {
        id: "net02",
        name: "linkedin",
        url: "https://www.linkedin.com/company/montebit/",
      },
      {
        id: "net03",
        name: "instagram",
        url: "https://www.instagram.com/montebit_/",
      },
      {
        id: "net04",
        name: "twitter",
        url: "https://twitter.com/MonteBit",
      },
    ],
  },
}